import { useAuth } from '../../context/AuthContext';

function PrivateRoute({ children }) {
    const { user, isLoggingOut } = useAuth();

    if (!user && !isLoggingOut) {
        window.location.href = `https://egide.defensoria.mt.def.br/oauth/authorize?client_id=${process.env.REACT_APP_EGIDE_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_EGIDE_REDIRECT_URI}/auth/callback&response_type=code`;

        return;
    }

    return children;
}

export default PrivateRoute;
